import { api } from './api';

// Define a service using a base URL and expected endpoints
export const usageLimitsApi = api.injectEndpoints({
  reducerPath: 'usageLimitsApi',
  tagTypes: ['UsageLimits'],
  endpoints: (builder) => ({
    getUsageLimits: builder.query({
      query: () => ({
        url: `/api/administration/usages/limits`,
        method: 'GET'
      }),
      keepUnusedDataFor: 0,
      providesTags: ['UsageLimits']
    }),
    deleteUsageLimit: builder.mutation({
      query: (id) => ({
        url: `/api/administration/usages/limits/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['UsageLimits']
    }),
    updateUsageLimit: builder.mutation({
      query: ({ id, usageLimitRequest }) => ({
        url: `/api/administration/usages/limits/${id}`,
        method: 'PATCH',
        body: usageLimitRequest
      }),
      invalidatesTags: ['UsageLimits']
    }),
    createUsageLimit: builder.mutation({
      query: ({ usageLimitRequest }) => ({
        url: `/api/administration/usages/limits`,
        method: 'POST',
        body: usageLimitRequest
      }),
      invalidatesTags: ['UsageLimits']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetUsageLimitsQuery,
  useUpdateUsageLimitMutation,
  useDeleteUsageLimitMutation,
  useCreateUsageLimitMutation
} = usageLimitsApi;
